import hero1 from "../assets/landing/client-meeting.jpeg";
import hero2 from "../assets/landing/contract-desk.jpeg";
import hero3 from "../assets/landing/law-books.jpeg";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="cl-hero" id="home">
      <div className="cl-hero-bg" aria-hidden>
        <div className="cl-hero-bg-photo" />
        <div className="cl-hero-bg-wash" />
        <span className="cl-hero-orb cl-hero-orb-gold" />
        <span className="cl-hero-orb cl-hero-orb-navy" />
      </div>

      <div className="cl-container cl-hero-grid">
        <div className="cl-hero-left">
          <h1>
            Smart Legal <br />
            Solutions
          </h1>

          <p className="cl-hero-sub">
            Find trusted legal professionals. Manage legal services. All in one secure platform.
          </p>

          <Link to="/plans/personal" className="btn btn-cta">View Service Packages</Link>
        </div>

        <div className="cl-hero-right">
          <div className="cl-hero-main">
            <img src={hero1} alt="Clients meeting with a legal professional" />
          </div>
          <div className="cl-hero-side">
            <img src={hero2} alt="Contract review with scales and gavel" />
            <img src={hero3} alt="Legal books and documents on a desk" />
          </div>
        </div>
      </div>
    </section>
  );
}
